import { j as e, a as _ } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { I as d } from "../../../../../Icon-D8QUNSZR.js";
import { I as o } from "../../../../../FeatureFlagProvider-BgPZZ37K.js";
import "react";
import "@ionic/react";
import { translate as p } from "../../../../string-table.js";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as i } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function j(L) {
  const {
    qualifications: S,
    isSwingHero: l,
    skillBuilderCompletedTasks: s = [],
    qualificationsDetails: c
  } = L;
  return /* @__PURE__ */ e(i, {
    title: p("SUB_PROFILE_QUALIFICATIONS_HEADER"),
    children: /* @__PURE__ */ _("div", {
      css: {
        marginTop: 8
      },
      children: [l && /* @__PURE__ */ e(o, {
        leftIcon: /* @__PURE__ */ e(d, {
          name: "Swing Hero"
        }),
        content: `${p("SUB_PROFILE_CONTACT_SWING")} ${p("SUB_PROFILE_CONTACT_HERO")}`,
        hasDivider: !0
      }), c ? c.map((r, n) => {
        var h, t;
        return /* @__PURE__ */ e("div", {
          children: /* @__PURE__ */ e(o, {
            leftIcon: /* @__PURE__ */ e(d, {
              name: "Verified"
            }),
            content: /* @__PURE__ */ _("div", {
              children: [/* @__PURE__ */ e("span", {
                children: r.name
              }), /* @__PURE__ */ e("ul", {
                css: {
                  margin: 0,
                  paddingLeft: "var(--spacing-lg)",
                  fontSize: 12
                },
                children: (r == null ? void 0 : r.subjects) && ((h = r == null ? void 0 : r.subjects) == null ? void 0 : h.length) > 0 && /* @__PURE__ */ e("li", {
                  children: (t = r == null ? void 0 : r.subjects) == null ? void 0 : t.join(", ")
                })
              })]
            }),
            hasDivider: !0
          })
        }, `${n}-${r}`);
      }) : S.map((r, n) => /* @__PURE__ */ e("div", {
        children: /* @__PURE__ */ e(o, {
          leftIcon: /* @__PURE__ */ e(d, {
            name: "Verified"
          }),
          content: /* @__PURE__ */ e("span", {
            children: r
          }),
          hasDivider: !0
        })
      }, `${n}-${r}`)), s.length > 0 && s.map((r, n) => /* @__PURE__ */ e("div", {
        children: /* @__PURE__ */ e(o, {
          leftIcon: /* @__PURE__ */ e(d, {
            name: "Lesson"
          }),
          content: `${r} (${p("SUB_PROFILE_QUALIFICATIONS_SKILL_BUILDER_SUB_LABEL")})`,
          hasDivider: !0
        })
      }, `${n}-${r}`))]
    })
  });
}
export {
  j as Qualifications
};
